export interface GroupArticles {
    id: number,
    denumire: string,
  }

export const initialGroupsArticlesState = {
    groupsArticles: [],
    groupsArticlesByGestiune: {},
};
  
export interface IGroupsArticlesState {
    groupsArticles: GroupArticles[],
    groupsArticlesByGestiune: Record<string, GroupArticles[]>;
}
  